import { Pipe, PipeTransform } from '@angular/core';

import { Document } from 'app/providers/storage-api/document.service';

@Pipe({
  name: 'experienceCardCheckbox',
  standalone: false,
})
export class ExperienceCardCheckboxPipe implements PipeTransform {
  transform(item: Document, selectedDocuments: Document[]): boolean {
    return selectedDocuments.some((doc) => doc.id === item.id);
  }
}
